export const DEFAULT_DATA_VIZ_NODE_COLORS = {
    route: "#2697A2",
    report: "#237062",
    actor: "#FF5F5F",
    permission: "#08BFAE",
    datasource: "#2F6E78",
    adapter: "#496A65",
    function: "#5B5FD6",
    operation: "#7C3AED",
    module: "#404F4D",
    schema: "#135E75",
    entity: "#1D7D86",
    field: "#C57A00",
    join: "#0F766E",
    pivot: "#D97706",
    status: "#CC4444",
    class: "#51CF66",
    method: "#FF8CC8",
    variable: "#FFD43B",
    type: "#9775FA",
    "flow-node": "#FF6B6B",
    protocol: "#4DABF7",
    artifact: "#94A3B8",
};
export const DEFAULT_DATA_VIZ_STATUS_COLORS = {
    allowed: "#08BFAE",
    limited: "#D97706",
    blocked: "#CC4444",
    neutral: "#64748B",
    active: "#4DABF7",
    inactive: "#64748B",
    warning: "#D97706",
    error: "#CC4444",
    success: "#08BFAE",
};
export const DEFAULT_DATA_VIZ_THEME = {
    background: "#F8FAF9",
    edgeColor: "#9CA3AF",
    edgeOpacity: 0.48,
    labelTextColor: "#233236",
    labelBackgroundColor: "rgba(255, 255, 255, 0.88)",
    labelBorderColor: "rgba(35, 112, 98, 0.28)",
    nodeFallbackColor: "#64748B",
    nodeColors: DEFAULT_DATA_VIZ_NODE_COLORS,
    statusColors: DEFAULT_DATA_VIZ_STATUS_COLORS,
    camera: {
        position: [0, 0, 420],
        fov: 46,
        near: 0.1,
        far: 2000,
    },
    lighting: {
        ambientIntensity: 1.9,
        directionalIntensity: 1.4,
        directionalPosition: [120, 160, 260],
    },
};
export const resolveDataVizTheme = (theme) => ({
    ...DEFAULT_DATA_VIZ_THEME,
    ...theme,
    nodeColors: {
        ...DEFAULT_DATA_VIZ_THEME.nodeColors,
        ...(theme?.nodeColors ?? {}),
    },
    statusColors: {
        ...DEFAULT_DATA_VIZ_THEME.statusColors,
        ...(theme?.statusColors ?? {}),
    },
    camera: {
        ...DEFAULT_DATA_VIZ_THEME.camera,
        ...(theme?.camera ?? {}),
    },
    lighting: {
        ...DEFAULT_DATA_VIZ_THEME.lighting,
        ...(theme?.lighting ?? {}),
    },
});
export const normalizeDataVizColor = (value, fallback) => value?.trim() || fallback;
export const dataVizColorToNumber = (value) => {
    const trimmed = value.trim();
    if (/^#[0-9a-f]{6}$/i.test(trimmed)) {
        return Number.parseInt(trimmed.slice(1), 16);
    }
    if (/^0x[0-9a-f]{6}$/i.test(trimmed)) {
        return Number.parseInt(trimmed.slice(2), 16);
    }
    return Number.parseInt(DEFAULT_DATA_VIZ_THEME.nodeFallbackColor.slice(1), 16);
};
//# sourceMappingURL=theme.js.map